"use client";

import { c as _c } from "react/compiler-runtime";
import InputComponent from "@/components/ui/InputComponent";
import { Suspense, use } from "react";
import { useTranslations } from "next-intl";
import { fetchFinishRegistrationEmail } from "../api";
type FinishRegistrationEmailInputProps = {
  emailPromise: ReturnType<typeof fetchFinishRegistrationEmail>;
};
export const FinishRegistrationEmailInput: React.FC<FinishRegistrationEmailInputProps> = props => {
  const $ = _c(14);
  const labels = useTranslations("Labels");
  const placeholders = useTranslations("Placeholders");
  const status = useTranslations("Status");
  let t0;
  if ($[0] !== labels) {
    t0 = labels("labelMail");
    $[0] = labels;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== status) {
    t1 = status("loading");
    $[2] = status;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== placeholders) {
    t2 = placeholders("placeholderMail");
    $[4] = placeholders;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const t3 = `${t1} ${t2}`;
  let t4;
  if ($[6] !== t0 || $[7] !== t3) {
    t4 = <InputComponent id="email" name="email" type="text" label={t0} placeholder={t3} staticDisplay={true} className="input--full" />;
    $[6] = t0;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== props) {
    t5 = <Content {...props} />;
    $[9] = props;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t4 || $[12] !== t5) {
    t6 = <Suspense fallback={t4}>{t5}</Suspense>;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
};
const Content: React.FC<FinishRegistrationEmailInputProps> = t0 => {
  const $ = _c(9);
  const {
    emailPromise
  } = t0;
  const labels = useTranslations("Labels");
  const placeholders = useTranslations("Placeholders");
  const {
    result,
    message
  } = use(emailPromise);
  let t1;
  if ($[0] !== labels) {
    t1 = labels("labelMail");
    $[0] = labels;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== placeholders) {
    t2 = placeholders("placeholderMail");
    $[2] = placeholders;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = result?.email;
  let t4;
  if ($[4] !== message || $[5] !== t1 || $[6] !== t2 || $[7] !== t3) {
    t4 = <InputComponent id="email" name="email" label={t1} placeholder={t2} type="text" staticDisplay={true} value={t3} error={message} className="input--full" />;
    $[4] = message;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
};